module.exports = __webpack_public_path__ + "media/assets/icons/shake-065ce7d5a59b8cac733968a0d5216ca0.svg";